/*
Usage example:
    - Layout
        <div id='zContainer' class='zContainerCls'>
            <input type="text" class='zInput1Cls'>
            <input type="text" id="zInput1">
            <input type="text" class='zInput2Cls'>
            <input type="text" id="zInput2">
        </div>

    - JS
        To initialize one of the lines below
            Use default selector  ':input[type=\"text\"]'
                $('#zContainer').eraser();
                $('.zContainerCls').eraser();

            Use custom selector
                $('#zContainer').eraser({sSelector: '.zInput1Cls, .zInput2Cls'});
                $('#zContainer').eraser({sSelector: '#zInput1, #zInput2'});
                $('.zContainerCls').eraser({sSelector: '.zInput1Cls, .zInput2Cls'});
                $('.zContainerCls').eraser({sSelector: '#zInput1, #zInput2'});

        To cleanup
            $('#zContainer').eraser('destroy');
            $('.zContainerCls').eraser('destroy');
//*/

/**
 * Plugin JQuery qui permet de rajouter un 'eraser' sur les champs 'input type text'
 *
 * @author Zébina Samuel <samuel.zebina@ac-versailles.fr>
 * @version 1.0
 */

(function (factory) {
    if(typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('dgrhEraser', ['jQuery', 'jQueryUi'], factory);
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($) {
    $.widget("dgrh.eraser", {
        options: {
            sSelector:                  ':input[type=\"text\"]',
            sFocusCls:                  'fltFocus',
            iEraserSize:                16,
            sErasableCls:               'erasable',
            sErasableGrayedInputCls:    'erasableGrayedInput',
            sErasableColoredInputCls:   'erasableColoredInput',
            afterErase:                 function(oElement) {}
        },

        _create: function () {
            var self    = this,
                options = this.options,
                oParent = $(this.element);

            //console.log('dgrh.eraser::_create ...', oParent, options);

            $(options.sSelector, oParent).each(function() {
                var oElement    = $(this),
                    bIsEmpty    = (0 === oElement.val().length);

                if(!bIsEmpty) {
                    self._setGrayedEraser(oElement);
                }
            });

            oParent.on('click mousemove mouseout focusin focusout change keyup', options.sSelector, function(oEvt) {
                var oElement = $(this);

                switch(oEvt.type) {
                case 'click':
                    self._onClick(oEvt, oElement);
                    break;
                case 'mousemove':
                    self._onMouseMove(oEvt, oElement);
                    break;
                case 'mouseout':
                    self._onMouseOut(oEvt, oElement);
                    break;
                case 'focusin':
                    self._onFocus(oEvt, oElement);
                    break;
                case 'focusout':
                    self._onBlur(oEvt, oElement);
                    break;
                case 'change':
                    self._onChange(oEvt, oElement);
                    break;
                case 'keyup':
                    self._onKeyup(oEvt, oElement);
                    break;
                }
            });
        },

        _init: function () {
            //console.log('dgrh.eraser::_init ...', $(this.element));
        },

        destroy: function() {
            var self    = this,
                options = this.options,
                oParent = $(this.element),
                aClass  = [
                   options.sFocusCls, 
                   options.sErasableCls, 
                   options.sErasableGrayedInputCls,
                   options.sErasableColoredInputCls
                ];

            //console.log('dgrh.eraser::destroy ...', oParent, options);

            $(options.sSelector, oParent).each(function() {
                $(this).removeClass(aClass.join(','));
            });

            oParent.off('click mousemove mouseout focusin focusout change keyup', options.sSelector);

            // Call the base destroy function.
            $.Widget.prototype.destroy.call(this);
        },

        _setColoredEraser: function(oElement) {
            var self    = this,
                options = this.options;

            oElement.removeClass(options.sErasableGrayedInputCls).addClass(options.sErasableColoredInputCls + ' ' + options.sErasableCls);
        },

        _setGrayedEraser: function(oElement) {
            var self    = this,
                options = this.options;

            oElement.removeClass(options.sErasableColoredInputCls + ' ' + options.sErasableCls).addClass(options.sErasableGrayedInputCls);
        },

        _removeEraser: function(oElement) {
            var self    = this,
                options = this.options;

            oElement.removeClass(options.sErasableColoredInputCls + ' ' + options.sErasableCls + ' ' + options.sErasableGrayedInputCls);
        },

        _onClick: function(oEvt, oElement) {
            var self    = this,
                options = this.options,
                x       = oEvt.pageX;
                oOffset = oElement.offset();
                iLimit  = oOffset.left + (oElement.outerWidth(true) - options.iEraserSize);

            if(x >= iLimit) {
                oElement.val('').change();
                options.afterErase(oElement);
            }
        },

        _onMouseMove: function(oEvt, oElement) {
            var self        = this,
                options     = this.options,
                x           = oEvt.pageX,
                oOffset     = oElement.offset(),
                iLimit      = oOffset.left + (oElement.outerWidth(true) - options.iEraserSize),
                bIsEmpty    = (0 === oElement.val().length);

            if(bIsEmpty) {
                return;
            }

            if(x >= iLimit) {
                self._setColoredEraser(oElement);
            } else {
                self._setGrayedEraser(oElement);
            }
        },

        _onMouseOut: function(oEvt, oElement) {
            var self        = this,
                options     = this.options,
                bIsEmpty    = (0 === oElement.val().length);

            if(!bIsEmpty) {
                self._setGrayedEraser(oElement);
            } else {
                self._removeEraser(oElement);
            }
        },

        _onFocus: function(oEvt, oElement) {
            var self        = this,
                options     = this.options;

            oElement.addClass(options.sFocusCls);
        },

        _onBlur: function(oEvt, oElement) {
            var self        = this,
                options     = this.options,
                bIsEmpty = (0 === oElement.val().length);

            oElement.removeClass(options.sFocusCls);
            if(bIsEmpty) {
                self._removeEraser(oElement);
            }
        },

        _onChange: function(oEvt, oElement) {
            var self        = this,
                options     = this.options,
                bIsEmpty    = (0 === oElement.val().length);

            if(!bIsEmpty) {
                self._setGrayedEraser(oElement);
            }
        },

        _onKeyup: function(oEvt, oElement) {
            var self        = this,
                options     = this.options,
                bIsEmpty = (0 === oElement.val().length);

            if(!bIsEmpty) {
                self._setGrayedEraser(oElement);
            } else {
                self._removeEraser(oElement);
            }
        }
    });
}));
